<template lang="pug">
v-row.mb-10
  v-container.fill-height(fluid, v-if="!loggedin")
    v-row(align="center", justify="center")
      v-col(cols="12", sm="8", md="4")
        v-card.elevation-12
          v-toolbar(color="primary", dark, flat)
            v-toolbar-title New Power Trip Account
            v-spacer
            v-btn(icon @click="back" v-if="!dealerMode")
              v-icon mdi-close-circle-outline
          v-card-text
            v-form(ref="form", v-model="valid", lazy-validation)
              v-text-field(
                :label="nameLabel",
                name="userName",
                prepend-icon="mdi-account",
                type="text",
                v-model="userName",
                :rules="[rules.required, rules.minimum]"
              )
              v-text-field(
                :label="emailLabel",
                name="email",
                prepend-icon="mdi-email",
                type="text",
                v-model="email",
                autocomplete="username",
                :rules="[rules.required, rules.email]"
              )
              v-text-field#password(
                label="Password",
                name="password",
                prepend-icon="mdi-lock",
                type="password",
                autocomplete="current-password",
                :rules="[rules.required, rules.minimum]"
                            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="() => (showPassword = !showPassword)"
            :type="showPassword ? 'text' : 'password'"
              )
              a(href="https://powertrip.earth/terms-and-conditions" target="_blank") Terms and Conditions
              v-checkbox(v-model="agreeTerms"          :true-value="1"
         :false-value="0"
         :rules="[v => v== 1 || 'You must agree to continue!']" label="Agree to Terms and Conditions")
                
            v-card-actions
              v-spacer
              v-btn(text, @click="login" v-if="!dealerMode") Use Existing Account
              v-btn(color="primary", @click="signup") Sign Up
    v-snackbar(v-model="snackbar", :timeout="4000") {{ messageText }}
</template>

<script>
import PowerTrip from "../services/api/PowerTrip.js";
import Vue from "vue";
import axios from "axios";
export default {
  props: ["dealerMode"],
  data() {
    return {
      messageText: "",
      snackbar: false,
      valid: true,
      loggedin: false,
      showPassword: false,
      userName: "",
      email: "",
      password: "",
      phone: "",
      agreeTerms: false,
      rules: {
        required: (value) => !!value || "Required.",
        minimum: (value) => (value && value.length >= 3) || "Minimum 3 Characters",
        counter: (value) => (value && value.length <= 20) || "Max 20 characters",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
  },
  mounted() {
    localStorage.removeItem("servicecode");
    localStorage.removeItem("credentials");
  },
  computed: {
    nameLabel() {
      return this.dealerMode ? "Customer Name" : "Your Name";
    },
    emailLabel() {
      return this.dealerMode ? "Customer Email" : "Your Email";
    },
  },
  methods: {
    back() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    login() {
      this.$router.push("/login");
    },
    async signup() {
      if (this.$refs.form.validate()) {
        var data = {
          email: this.email,
          password: this.password,
          name: this.userName,
          phone: this.phone,
        };
        // if (this.dealerMode) {
        data.dealer = this.$dealer.serviceCode;
        // }
        this.snackbar = true;
        this.messageText = "Creating Account...";
        var results = await PowerTrip.newAccount(data);
        console.log(results);
        if (results.status == "ok") {
          if (this.dealerMode) {
            this.snackbar = true;
            this.messageText = "Account Created for " + this.userName;
            this.email = "";
            this.password = "";
            this.userName = "";
            this.phone = "";

            return;
          }
          this.snackbar = true;
          this.messageText = "Creating Account...";
          var result = await PowerTrip.login(data);
          console.log(result);
          if (result.id) {
            //load saved trips
            var trips = await PowerTrip.getTrips(data);
            console.log(trips);
            // store token locally
            Vue.prototype.$user = result;
            if (result.trips) {
              Vue.prototype.$trips = JSON.parse(result.trips);
            }
            // Vue.prototype.$auth = data;
            localStorage.setItem("token", result.token);
            axios.defaults.headers.common["X-Auth-Powertrip"] = result.token;
            this.$router.push("/planner");
          } else {
            this.snackbar = true;
            this.messageText = "Unable to sign up with these details.";
          }
        } else {
          this.snackbar = true;
          this.messageText = "Unable to create account - do you already have an account?";
        }
      }
    },
  },
};
</script>
<style scoped>
header {
  min-height: 64px;
}
</style>
